import { ValidateState } from "lib.common";
import { PtrnColors, PtrnIcons } from "../../patronTypes";

export const PtrnDialogsMap = {
   [ValidateState.ERROR]: {
      icon: PtrnIcons.error,
      color: PtrnColors.error,
      titulo: 'Error',
      textCerrar: 'Cerrar',
   },
   [ValidateState.INFO]: {
      icon: PtrnIcons.info,
      color: PtrnColors.info,
      titulo: 'Nueva Información',
      textCerrar: 'Cerrar'
   },
   [ValidateState.WARNING]: {
      icon: PtrnIcons.warning,
      color: PtrnColors.warning,
      titulo: 'Advertencia',
      textCerrar: 'Cerrar'
   },
   [ValidateState.SUCCESS]: {
      icon: PtrnIcons.success,
      color: PtrnColors.success,
      titulo: 'Fue un Éxito',
      textCerrar: 'Aceptar'
   },
}


export const copyFn = (shortMessage: string, longMessage: string, esModoDev: boolean) => {
   return () => {
      if (esModoDev) {
         navigator.clipboard.writeText(
            JSON.stringify({ shortMessage: shortMessage, longMessage: longMessage }, null, 2)
         );
      } else {
         navigator.clipboard.writeText(`${shortMessage}\n\n${longMessage}`);
      }
   };
};